import { render } from "./CooperativeHome.vue?vue&type=template&id=17a0535a&scoped=true&ts=true"
import script from "./CooperativeHome.vue?vue&type=script&lang=ts"
export * from "./CooperativeHome.vue?vue&type=script&lang=ts"

import "./CooperativeHome.vue?vue&type=style&index=0&id=17a0535a&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a0535a"]])

export default __exports__